export default __webpack_public_path__ + "media/images/mailer/icon_lock_open-fc03914de207c75134dc2950490500c6.png";